import type { ISubscribe } from './ISubscribe';

export enum EMultiFunctionButtonType  {
    SUBSCRIBE_POPUP='popup',
    LINK='link',
    ADD_TO_CART='addToCart',
    SUBSCRIBE='subscribe',
    IMAGE='image'
}

export interface IMultiFunctionButton extends ISubscribe {
    type: EMultiFunctionButtonType;
    text: string;
    ghost?: boolean;
    productId?: string;
    addCartGtag?: string;
    addCartFinishLink?: string;
    addCartErrorMsg?: string;
    popupTitle?: string;
    link?: string;
    color?: string;
    borderColor?: string;
    backgroundColor?: string;
    activeColor?: string;
    activeBackgroundColor?: string;
    activeBorderColor?: string;
}
